<template>
  <div class="icon-box">
    <q-img class="icon" :src="src" :ratio="1/1" contain />
    <div class="caption">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: String
  }
};
</script>

<style scoped>
.icon-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon {
  max-width: 60pt;
  opacity: 0.75;
}
.caption {
  flex: 0 0 auto;
  font-size: 75%;
  align-self: center;
  text-align: center;
  margin-top: 10pt;
}
</style>
